/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Section_AdvancedInputs */



/**
* | output |
* | --- |
* | "Advanced Permissions" |
*
* @param {Leveling_Perm_Section_AdvancedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_section_advanced = /** @type {((inputs?: Leveling_Perm_Section_AdvancedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Section_AdvancedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширенные права")
	return /** @type {LocalizedString} */ ("Advanced Permissions")
});